import { createAction } from 'redux-actions';

export const SET_ERROR = 'SET_ERROR';
export const setError = createAction(SET_ERROR);
